import classNames from 'classnames';
import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';

type VideosNoConsentCardProps = ComponentProps<'div'> & { openCookiesConsent: () => void };

export function VideosNoConsentCard({ openCookiesConsent, className, ...props }: VideosNoConsentCardProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openCookiesConsent();
  };
  return (
    <div
      className={classNames('bg-royal-blue p-3 d-flex align-items-center justify-content-center', className)}
      {...props}
    >
      <p className="text-white text-start fs-6">
        <FormattedMessage
          id="discover.videos.noConsent"
          values={{
            link: parts => (
              <a href="#" onClick={handleClick} className="text-link">
                {parts}
              </a>
            ),
          }}
        />
      </p>
    </div>
  );
}
